// type RouteMapper = string | ((value: string) => string) | { [path: string]: RouteMapper }
export type RouteMapper = {
  // root: string
  // breadcrumb?: ((value: string) => string) | string
  [path: string]: string | RouteMapper | ((value: string) => string)
}

export const ROUTES = {
  root: '/',
  login: {
    root: '/Entrar',
  },
  dashboard: {
    root: '/Painel',
    breadcrumb: 'Painel',
    users: {
      root: '/Usuarios',
      add: {
        root: '/Novo',
      },
      detail: {
        root: '/:userId',
      },
    },
    clients: {
      root: '/Clientes',
      add: {
        root: '/Novo',
      },
      detail: {
        root: '/:clientId',
        locations: {
          root: '/Localizacoes',
          detail: {
            root: '/:locationId',
          },
        },
      },
    },
    products: {
      root: '/Produtos',
      add: {
        root: '/Novo',
      },
      detail: {
        root: '/:varietyId',
      },
    },
    inventory: {
      root: '/Estoques',
      breadcrumb: 'Estoque',
      resource: {
        root: '/Insumos',
      },
      tickets: {
        root: '/Compras',
      },
      organization: {
        root: '/Viveiro',
        breadcrumb: 'Viveiro',
        selected: {
          root: '/:organizationId',
          breadcrumb: (name: string): string => name,
          resource: {
            root: '/Insumos',
            selected: {
              root: '/:categoryUrl',
            },
          },
          tray: {
            root: '/Bandejas',
          },
          seed: {
            root: '/Sementes',
            breadcrumb: 'Sementes',
          },
        },
      },
      client: {
        root: '/Cliente',
        resource: {
          root: '/Insumos',
          selected: {
            root: '/:categoryUrl',
          },
        },
        tray: {
          root: '/Bandejas',
        },
        seed: {
          root: '/Sementes',
        },
      },
    },
    infrastructure: {
      root: '/Estruturas',
      germinationRoom: {
        root: '/Germinacao',
      },
      healingRoom: {
        root: '/Cicatrizacao',
      },
      greenhouse: {
        root: '/Estufa',
      },
      vehicle: {
        root: '/Veiculo',
      },
      tray: {
        root: '/Bandeja',
      },
    },
  },
  orders: {
    root: '/Pedidos',
    details: {
      root: '/:orderId',
    },
    items: {
      root: '/Itens',
      id: {
        root: '/:prodItemId',
      },
    },
    new: {
      root: '/Novo',
    },
  },
  seeding: {
    root: '/Semeio',
  },
  development: {
    root: '/Desenvolvimento',
  },
  transport: {
    root: '/Entrega',
  },
};
